module.exports = __webpack_public_path__ + "media/shared/assets/img/placeholders/placeholder_2x3-af5b0b7e981018a2a7d3d1d853da9e3a.jpg";